
import { SEO } from "@/components/common/SEO";
import { Header } from "@/components/learn-more/Header";
import { Footer } from "@/components/learn-more/Footer";
import { BlogList } from "@/components/blog/BlogList";
import { BlogSidebar } from "@/components/blog/BlogSidebar";
import { generatePageStructuredData } from "@/utils/seoUtils";

export default function Blog() {
  const pageStructuredData = generatePageStructuredData(
    "Blog | Hour Tracker - Time Tracking for Freelancers",
    "Explore freelancer tips, productivity hacks, and invoicing best practices on the Hour Tracker blog.",
    "https://www.hourtracker.info/blog"
  );
  
  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Blog | Hour Tracker - Time Tracking for Freelancers"
        description="Explore freelancer tips, productivity hacks, and invoicing best practices on the Hour Tracker blog."
        keywords="freelance blog, time tracking tips, invoice best practices, freelancer productivity, billable hours management"
        structuredData={pageStructuredData}
      />
      
      <Header />
      
      <main className="flex-1 py-12 bg-gradient-to-b from-gray-50 to-white">
        <div className="container px-4 sm:px-6">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gradient">Hour Tracker Blog</h1>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
              Resources, tips, and strategies to help freelancers and small businesses track time more effectively and get paid faster.
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mt-12">
            <div className="lg:col-span-8">
              <BlogList />
            </div>
            <div className="lg:col-span-4">
              <BlogSidebar />
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
